"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("../../utils/jsonschema");
var schema = {
    $id: jsonschema_1.$id('objectExpression'),
    title: 'Object expression',
    anyOf: [
        {
            type: 'object',
            properties: {
                $expression: {
                    type: 'null'
                }
            },
            additionalProperties: true
        },
        { $ref: jsonschema_1.$id('mergeExpression') },
        { $ref: jsonschema_1.$id('untypedResolvedExpression') }
    ]
};
exports.default = schema;
//# sourceMappingURL=object.schema.js.map